import { gql, useQuery } from "@apollo/client";
import { 
  OfferTypeOverview, 
  PublishedOffersOverviewQueryQuery 
} from "../../../../../schemaTypes";

export const publishedOffersOverviewQuery = gql`
  query PublishedOffersOverviewQuery {
    publishedOffersOverview {
      offerTypes {
        offerType
        count
      }
      totalOffers
    }
  }
`;

export interface WithPublishedOffersOverview {
  offerTypes: OfferTypeOverview[];
  totalOffers: number;
}

interface Props {
  children: (data: WithPublishedOffersOverview) => React.ReactElement | null;
}

export const PublishedOffersOverviewController: React.FC<Props> = ({ children }) => {
  const { data } = useQuery<PublishedOffersOverviewQueryQuery>(publishedOffersOverviewQuery);
  const offerTypes = data?.publishedOffersOverview.offerTypes ?? [];
  const totalOffers = data?.publishedOffersOverview.totalOffers ?? 0;
  
  return children({ offerTypes, totalOffers });
};